import * as Yup from "yup";
import i18n from "../i18n";

export const ActiveDirectoryConfigSchema = Yup.object({
  username: Yup.string()
    .required(
      i18n.language === "en" ? "Username is required" : "اسم المستخدم مطلوب"
    )
    .max(
      25,
      i18n.language === "en"
        ? "Username must be at most 25 characters"
        : "يجب أن يكون اسم المستخدم 25 حرفًا كحد أقصى"
    ),
  password: Yup.string()
    .required(
      i18n.language === "en" ? "Password is required" : "كلمة المرور مطلوبة"
    )
    .max(
      20,
      i18n.language === "en"
        ? "Password must be at most 20 characters long"
        : "يجب ألا تتجاوز كلمة المرور 20 حرفًا"
    ),
  // .min(
  //   8,
  //   i18n.language === "en"
  //     ? "Password must be at least 8 characters long"
  //     : "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل"
  // )
  // .matches(
  //   /[A-Z]/,
  //   i18n.language === "en"
  //     ? "Must include at least one uppercase letter"
  //     : "يجب أن تحتوي على حرف واحد على الأقل كبير"
  // )
  // .matches(
  //   /[a-z]/,
  //   i18n.language === "en"
  //     ? "Must include at least one lowercase letter"
  //     : "يجب أن تحتوي على حرف واحد على الأقل صغير"
  // )
  // .matches(
  //   /\d/,
  //   i18n.language === "en"
  //     ? "Must include at least one number"
  //     : "يجب أن تحتوي على رقم واحد على الأقل"
  // )
  // .matches(
  //   /[!@#$%^&*(),.?":{}|<>]/,
  //   i18n.language === "en"
  //     ? "Must include at least one special character"
  //     : "يجب أن تحتوي على رمز خاص واحد على الأقل"
  // )
  domain: Yup.string()
    .required(i18n.language === "en" ? "Domain is required." : "المجال مطلوب.")
    .max(
      25,
      i18n.language === "en"
        ? "Domain must be at most 30 characters"
        : "يجب أن يكون المجال 30 حرفًا كحد أقصى"
    ),
  ldapPath: Yup.string().required(
    i18n.language === "en" ? "LDAP Path is required." : "مسار LDAP مطلوب."
  ),
  adUserGroupName: Yup.string().max(
    25,
    i18n.language === "en"
      ? "AD User Group Name must be at most 25 characters"
      : "يجب أن يكون اسم مجموعة مستخدمي Active Directory 25 حرفًا كحد أقصى"
  ),
});
